import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setSearchQuery, setSearchInput, unsetSearchQuery, unsetSearchInput } from '../actions';
import { getSearchQuery, getSearchInput } from '../selectors';

export type WithSearchProps = {
  searchQuery?: string;
  searchInput: string;
  setSearchQuery(query: string, allowSearchByUrl?: boolean): void;
  setSearchInput(value: string): void;
  unsetSearchQuery(): void;
  unsetSearchInput(): void;
};

export const useSearch = (): WithSearchProps => ({
  ...useMMSelector(
    state => ({
      searchQuery: getSearchQuery(state),
      searchInput: getSearchInput(state),
    }),
    shallowEqual
  ),
  ...useMMDispatchActions({
    setSearchQuery,
    unsetSearchQuery,
    setSearchInput,
    unsetSearchInput,
  }),
});

export default connectMediaStore(
  state => ({
    searchQuery: getSearchQuery(state),
    searchInput: getSearchInput(state),
  }),
  { setSearchQuery, unsetSearchQuery, setSearchInput, unsetSearchInput }
);
